import {
  GET_REIMBURSEMENTTYPE,
  GET_REIMBURSEMENTTYPE_SUCCESS,
  GET_REIMBURSEMENTTYPE_FAIL,
  DELETE_REIMBURSEMENTTYPE,
  DELETE_REIMBURSEMENTTYPE_SUCCESS,
  DELETE_REIMBURSEMENTTYPE_FAIL,
  UPDATE_REIMBURSEMENTTYPE,
  UPDATE_REIMBURSEMENTTYPE_SUCCESS,
  UPDATE_REIMBURSEMENTTYPE_FAIL,
  ADD_NEW_REIMBURSEMENTTYPE,
  ADD_REIMBURSEMENTTYPE_SUCCESS,
  ADD_REIMBURSEMENTTYPE_FAIL,
  REIMBURSEMENTTYPE_LOADING,
  REIMBURSEMENTTYPE_RESET,
} from "./actionType";

export const resetReimbursementTypeState = (actionType) => ({
  type: REIMBURSEMENTTYPE_RESET,
  payload: { actionType },
});

export const getReimbursementTypeSuccess = (actionType, data) => ({
  type: GET_REIMBURSEMENTTYPE_SUCCESS,
  payload: { actionType, data },
});

export const getReimbursementTypeFail = (actionType, error) => ({
  type: GET_REIMBURSEMENTTYPE_FAIL,
  payload: { actionType, error },
});

export const getReimbursementType = data => ({
  type: GET_REIMBURSEMENTTYPE,
  payload: data,
});

export const getReimbursementTypeLoading = () => ({
  type: REIMBURSEMENTTYPE_LOADING
});

export const deleteReimbursementType = data => ({
  type: DELETE_REIMBURSEMENTTYPE,
  payload: data,
});

export const deleteReimbursementTypeSuccess = data => ({
  type: DELETE_REIMBURSEMENTTYPE_SUCCESS,
  payload: data,
});

export const deleteReimbursementTypeFail = error => ({
  type: DELETE_REIMBURSEMENTTYPE_FAIL,
  payload: error,
});

export const updateReimbursementType = data => ({
  type: UPDATE_REIMBURSEMENTTYPE,
  payload: data,
});

export const updateReimbursementTypeFail = error => ({
  type: UPDATE_REIMBURSEMENTTYPE_FAIL,
  payload: error,
});

export const updateReimbursementTypeSuccess = data => ({
  type: UPDATE_REIMBURSEMENTTYPE_SUCCESS,
  payload: data,
});

export const addNewReimbursementType = data => ({
  type: ADD_NEW_REIMBURSEMENTTYPE,
  payload: data,
});

export const addReimbursementTypeSuccess = data => ({
  type: ADD_REIMBURSEMENTTYPE_SUCCESS,
  payload: data,
});

export const addReimbursementTypeFail = error => ({
  type: ADD_REIMBURSEMENTTYPE_FAIL,
  payload: error,
});